exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-tip-element-wrapper[data-v-2344c6ec]{background:$white;padding:4px 15px;border-radius:3px;color:$secondary;font-size:12px}", ""]);

// exports
